import * as Sentry from '@sentry/browser';

import DbManagerService from '@/services/benchmarks/DbManagerService';
import { setupMutationTypes } from '../mutation-types';

export async function updateBenchmarksById({ commit }, { expiryDate, id }) {
  try {
    commit(setupMutationTypes.UPDATE_BENCHMARKS_LOADING, true);
    commit(setupMutationTypes.UPDATE_BENCHMARKS_ERROR, false);

    const { data } = await DbManagerService.updateBenchmarks({ expiryDate, id });

    return data;
  } catch (e) {
    commit(setupMutationTypes.UPDATE_BENCHMARKS_ERROR, true);
    Sentry.captureException(e);
    console.error(e);
    throw e;
  } finally {
    commit(setupMutationTypes.UPDATE_BENCHMARKS_LOADING, false);
  }
}
